import React from 'react';
import Button from '@material-ui/core/Button';
import ellipsisIcon from '../../assets/svg/ellipsis.svg';
import spinnerIcon from '../../assets/svg/spinner.svg';
import rippleIcon from '../../assets/svg/Ripple.svg';
import spinIcon from '../../assets/svg/spin.svg';
import circularIcon from '../../assets/svg/Circular.svg';
import thinCircularIcon from '../../assets/svg/ThinCircular.svg';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

const ProgressiveButton = ({
  children,
  onClick = null,
  disabled,
  loading = false,
  startIcon,
  endIcon,
  animation = 'default',
  ...rest
}) => {
  const animations = {
    default: <img src={ellipsisIcon} alt="" width={24} height={24} />,
    ripple: <img src={rippleIcon} alt="" width={24} height={24} />,
    spin: <img src={spinIcon} alt="" width={24} height={24} />,
    spinner: <img src={spinnerIcon} alt="" width={24} height={24} />,
    circular: <img src={circularIcon} alt="" width={24} height={24} />,
    thinCircular: <img src={thinCircularIcon} alt="" width={24} height={24} />,
  };
  
  const progressIcon = loading ? animations[animation] : null;
  endIcon = endIcon ? progressIcon || endIcon : null;
  startIcon = startIcon ? progressIcon || startIcon : null;
  return (
    <Button
      onClick={disabled ? null : onClick}
      endIcon={endIcon}
      startIcon={startIcon}
      {...rest}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};

export default React.memo(ProgressiveButton);
